import { PROFILE, PROFILE_EDIT} from "constants/urls";
import { RouteObject } from "react-router-dom";

// eslint-disable-next-line import/no-anonymous-default-export
export default [  
  {
    path: PROFILE,
    lazy: () => import("./routes/Profile"),
  },
  {
    path: PROFILE_EDIT,
    lazy: () => import("./routes/profile-edit"),
  },
] as RouteObject[];
